import React, { useState } from 'react';
import { Button, Label, TextInput, Card, Alert, Spinner } from 'flowbite-react';

const API_URL = process.env.REACT_APP_DASHBOARD_API || 'http://localhost:8000/dashboard-api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Ошибка входа');
      localStorage.setItem('dashboard_token', data.access_token);
      window.location.href = '/apps';
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-[80vh]">
      <Card className="w-full max-w-md text-gray-900">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center mb-4">
            <span className="text-4xl mr-3">🏠</span>
            <div>
              <h1 className="text-3xl font-bold">
                <span className="text-blue-600">Real</span>
                <span className="text-gray-800">gram</span>
              </h1>
              <p className="text-sm text-gray-500">Панель управления</p>
            </div>
          </div>
          <h2 className="text-xl font-semibold">Вход в систему</h2>
          <p className="mt-2 text-sm text-gray-600">Платформа для управления недвижимостью в телеграм</p>
          <p className="text-sm text-gray-600">Сделано с ❤️ для агентов недвижимости</p>
        </div>
        {error && (
          <Alert color="failure" className="mt-2">
            {error}
          </Alert>
        )}
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div>
            <Label htmlFor="email" value="Email" />
            <TextInput id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div>
            <Label htmlFor="password" value="Пароль" />
            <TextInput id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <Button type="submit" disabled={loading} color="blue">
            {loading ? (<div className="flex items-center gap-2"><Spinner size="sm" /> Вход...</div>) : 'Войти'}
          </Button>
          <div className="text-center text-sm text-gray-500">
            Нет аккаунта? <a href="/register" className="underline underline-offset-2 decoration-blue-500 hover:text-blue-700">Зарегистрироваться</a>
          </div>
        </form>
      </Card>
    </div>
  );
}
